import { combineReducers } from 'redux';

import authReducer from './reducers/reducer';
import profesorReducer from './reducers/profesorReducer';
import estudianteReducer from './reducers/estudianteReducer';

export const rootReducer = combineReducers({
	auth: authReducer,
	profesor: profesorReducer,
	estudiante: estudianteReducer
});
